import { IAccountingSuggestion } from '@root/query/suggestions'
import React from 'react'
import { DropzoneInputProps, DropzoneRootProps } from 'react-dropzone'
import { SuggestionCardSurface } from '../styles'
import { SuggestionCardAccrualSection } from './SuggestionCardAccrualSection'
import { SuggestionCardAttachmentsSection } from './SuggestionCardAttachmentsSection'
import { SuggestionCardDetailsSection } from './SuggestionCardDetailsSection'
import { SuggestionCardHeader } from './SuggestionCardHeader'

interface SuggestionCardFrontContentProps {
  suggestion: IAccountingSuggestion
  formId: string
  handleAccept: React.FormEventHandler<HTMLFormElement>
  showManualContactSelector?: boolean
  contactSelectorOpenRequestId?: number
  onShowManualContactSelector?: () => void
  onUseSuggestedContact: () => void
  isCardDragActive: boolean
  getCardDropzoneRootProps: <T extends DropzoneRootProps>(props?: T) => T
  getCardDropzoneInputProps: <T extends DropzoneInputProps>(props?: T) => T
  documentId: number
  attachmentIds: number[]
  onAttachmentIdsChange: (nextAttachmentIds: number[]) => void
}

export const SuggestionCardFrontContent: React.FC<SuggestionCardFrontContentProps> = ({
  suggestion,
  formId,
  handleAccept,
  onUseSuggestedContact,
  isCardDragActive,
  getCardDropzoneRootProps,
  getCardDropzoneInputProps,
  documentId,
  attachmentIds,
  onAttachmentIdsChange
}) => {
  return (
    <SuggestionCardSurface
      key={`suggestion-${suggestion.id}`}
      $isDragActive={isCardDragActive}
      {...getCardDropzoneRootProps({ 'data-test': 'suggestion-card-dropzone' })}
    >
      <form id={formId} style={{ width: '100%' }} onSubmit={handleAccept}>
        <input {...getCardDropzoneInputProps()} />
        <SuggestionCardHeader suggestion={suggestion} />
        {suggestion.accrual_split.enabled && (
          <SuggestionCardAccrualSection suggestion={suggestion} />
        )}
        <SuggestionCardDetailsSection
          suggestion={suggestion}
          onUseSuggestedContact={onUseSuggestedContact}
        />
        <SuggestionCardAttachmentsSection
          suggestion={suggestion}
          documentId={documentId}
          attachmentIds={attachmentIds}
          onAttachmentIdsChange={onAttachmentIdsChange}
        />
      </form>
    </SuggestionCardSurface>
  )
}
